/**
 * Shared saved-search constants and the entry shape.
 *
 * This module used to also house a localStorage-backed store
 * (`createSavedSearchStore`) shared by the Search and Track pages, along with
 * its repair machinery and config/store types. That persistence has moved to
 * the backend UserPreference API (see `useUserPreferences`) — exactly the
 * migration the original TEMPORARY-storage note here anticipated ("Long term
 * these move into the users DynamoDB table ... this module ... is deleted
 * outright"). Only the pieces still used by the backend hooks and the Track
 * help tip remain.
 */

/** Default number of saved searches kept before the oldest is evicted. */
export const DEFAULT_MAX_SAVED_SEARCHES = 5;

/**
 * Save Search info-tip copy. `TrackFilters` is the sole renderer — the Search
 * panel footer no longer shows an info tip, so the Track Translations page is
 * the only place this copy reaches the screen. It stays here rather than moving
 * next to `TrackFilters` so the wording has one home if a second surface ever
 * needs it.
 */
export const SAVE_SEARCH_HELP_TEXT =
  'Save your current search filters as a bookmark for quick access. ' +
  `Up to ${DEFAULT_MAX_SAVED_SEARCHES} searches are saved — if you save a ` +
  `${DEFAULT_MAX_SAVED_SEARCHES + 1}th, the oldest is auto-deleted.`;

/** A single saved search entry, generic over the state each page persists. */
export interface SavedSearchEntry<TState> {
  id: string;
  label: string;
  state: TState;
  savedAt: number;
}
